<div class="container">
    <page-title [title]="title"></page-title>
    <p>Veja abaixo os exames disponíveis, se preferir, realize sua busca no campo abaixo:</p>
    <div  class="row">        
        <div class="col-xs-12">
            <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Digite sua busca pelo nome do exame</mat-label>
                <input type="text" matInput  [(ngModel)]="search"  
                placeholder="Digite aqui sua busca">          
            </mat-form-field>
        </div>       
        <!-- <div class="col-xs-12 col-md-3">
            <button  mat-flat-button color="primary" (click)="pesquisar()" [disabled]="loading" >Buscar</button>
        </div>     -->
    </div> 
    <div class="col-xs-12 col-lg-6 "  *ngFor="let procedure of proceduresFilter">
        <mat-card  (click)="openComponentDialogScheduleRegistrationForm(procedure)">
                <div class="content">
                <b>{{procedure.name }}<span  [innerHTML]="getHospitalName(procedure)"></span></b>
                <div  [innerHTML]="getCity(procedure)"></div>               
                </div>

        </mat-card>
    </div>
</div>